module.exports = __webpack_public_path__ + "img/tramite2.bb174dc3.svg";